<template>
    <div>
        <b-navbar toggleable="lg" type="light" variant="white">
            <div class="container">

                <b-navbar-brand v-if="!isAdmin" :to="{ name: 'Tools' }">
                    <img src="@/assets/images/logo.png" class="logo_img" />
                </b-navbar-brand>
                <b-navbar-brand v-if="isAdmin" :to="{ name: 'Tools' }">
                    <img src="@/assets/images/logo.png" class="logo_img" />
                </b-navbar-brand>

                <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

                <b-collapse id="nav-collapse" is-nav v-if="Object.keys(getUserDetails).length > 0">

                    <!-- normal user menu-->
                    <b-navbar-nav  v-if="!isAdmin">
<!--                        <b-nav-item :to="{ name: 'Home' }" exact active-class="active">Domov</b-nav-item>-->
                        <b-nav-item :to="{ name: 'Tools' }" exact active-class="active">Orodja</b-nav-item>
                        <b-nav-item :to="{ name: 'EditTool' }" exact active-class="active" class="ml-3"><i class="fa fa-plus"></i> Dodaj orodje</b-nav-item>
                    </b-navbar-nav>

                    <!-- admin user menu-->
                    <b-navbar-nav  v-if="isAdmin">
<!--                        <b-nav-item :to="{ name: 'Home' }" exact active-class="active">Domov</b-nav-item>-->
                        <b-nav-item :to="{ name: 'Tools' }" exact active-class="active">Orodja</b-nav-item>
                        <b-nav-item :to="{ name: 'Users' }" exact active-class="active">Uporabniki</b-nav-item>
                        <b-nav-item :to="{ name: 'EditTool' }" exact active-class="active" class="ml-3"><i class="fa fa-plus"></i> Dodaj orodje</b-nav-item>
                    </b-navbar-nav>



                    <div class="ml-auto" v-if="Object.keys(getUserDetails).length > 0">

                        <b-dropdown dropdown :text="userData.displayName" variant="primary" class="m-2">
                            <b-dropdown-item @click="logout()">Odjavi se</b-dropdown-item>
                        </b-dropdown>

                    </div>

                </b-collapse>
            </div>
        </b-navbar>
    </div>
</template>

<script>
  import firebase from 'firebase'

  export default {
    name: 'Header',
    data: function () {
      return {
        userData: {},
        isAdmin: sessionStorage.getItem("HRAM_user") ? JSON.parse(sessionStorage.getItem("HRAM_user")).administrator : false
      }
    },
    updated() {
      console.log("Updated");
      this.isAdmin = sessionStorage.getItem("HRAM_user") ? JSON.parse(sessionStorage.getItem("HRAM_user")).administrator : false
    },
    computed: {
      getUserDetails() {
        this.userData = this.$store.getters.getUserDetails;
        return this.$store.getters.getUserDetails;
      }
    },
    mounted () {
      let _this = this;
      _this.$store.dispatch("retrieveUserDetails");
    },
    methods: {
      logout() {
        const _this = this;
        _this.userData = {};
        sessionStorage.clear();
        _this.$store.dispatch("retrieveUserDetails");
        _this.$router.replace('/login');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Header.vue